<ac-auth-frame>

  <ng-template authenticationFailedContent>
    <ac-authentication-failed></ac-authentication-failed>
  </ng-template>

  <ng-template authenticatedContent>
    <ac-app-frame></ac-app-frame>
  </ng-template>

  <ng-template unauthenticatedContent>
    <sc-flex fitHeight [centered]="true" [gap]="128" [vertical]="vertical">

      <div class="login-screen">
        <sc-sub-title><sc-dictionary-label
            dictionaryKey="common.app-client.ui.login.use-existing-account-for-login"></sc-dictionary-label></sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <ac-login-mask></ac-login-mask>
        <sc-content-spacer vertical double></sc-content-spacer>
        <sc-sub-title><sc-dictionary-label
            dictionaryKey="common.app-client.ui.login.use-alternative-account-for-login"></sc-dictionary-label></sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <ac-oauth-selection></ac-oauth-selection>
      </div>

      <div class="language-selection">
        <sc-sized-container [minWidth]="440">
          <sc-context-language-selection-list [flagWidth]="100"></sc-context-language-selection-list>
        </sc-sized-container>
      </div>

    </sc-flex>
  </ng-template>

  <ng-template addLicenseContent>
    <sc-flex fitHeight centered>
      <sc-sized-container [maxWidth]="800">
        <ac-add-license></ac-add-license>
      </sc-sized-container>
    </sc-flex>
  </ng-template>

  <ng-template confirmInvitationContent>
    <sc-flex fitHeight [centered]="true">
      <div>
        <sc-flex stretchContent>
          <div>
            <ac-invitation-details></ac-invitation-details>
          </div>
          <sc-content-spacer double></sc-content-spacer>
          <ac-confirm-invitation></ac-confirm-invitation>
        </sc-flex>
      </div>
    </sc-flex>
  </ng-template>

   <ng-template requestPasswordResetContent>
    <sc-flex [fitHeight]="true" [centered]="true" [gap]="128">
      <div class="request-password-change-screen">
        <sc-title>Passwortänderung anfordern</sc-title>
        <sc-content-spacer vertical half></sc-content-spacer>
        <sc-sub-title>Geben Sie Ihren Benutzernamen an. Im Anschluss erhalten Sie einen Link zur Neuvergabe Ihres Passworts an die hinterlegte E-Mail-Adresse.</sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <ac-request-password-reset></ac-request-password-reset>
      </div>
    </sc-flex>
  </ng-template>

  <ng-template confirmPasswordResetContent>
    <sc-flex [fitHeight]="true" [centered]="true" [gap]="128">
      <div class="request-password-change-screen">
        <sc-title>Neues Passwort vergeben</sc-title>
        <sc-content-spacer vertical half></sc-content-spacer>
        <sc-sub-title>Geben Sie hier Ihr neues Passwort ein.</sc-sub-title>
        <sc-content-spacer vertical></sc-content-spacer>
        <ac-confirm-password-reset></ac-confirm-password-reset>
      </div>
    </sc-flex>
  </ng-template>

</ac-auth-frame>
